import React, { Component } from "react";
import Videomonster from "@/_mobile/RenderComponent/Videomonster";
import Video09 from "@/_mobile/RenderComponent/Video09";
import DataManager from "@/utils/DataManager";



class MobileRender extends Component {

  renderComponent = () => {
    // if (DataManager.IsProvider(DataManager.PROVIDER.VIDEO09)) return <Video09 {...this.props} />;

    return <Videomonster {...this.props} />;
  };

  render() {
    return this.renderComponent();
  }
}

export default MobileRender;
